export default "__VITE_ASSET__DXBahAAK__"